import Modal from "@material-ui/core/Modal";
import TeacherPortalStudentTabPanel from "./StudentTabPanel";

const TeacherPortalStudentModal = ({ student, activities, quizesOfStudent, onClose, activitiesWithUsageData}) => {
    return <Modal open onClose={() => { onClose() }}>
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-4/5 h-3/5 overflow-scroll bg-white rounded shadow outline-none">
            <TeacherPortalStudentTabPanel student={student} activities={activities} quizesOfStudent = {quizesOfStudent} activitiesWithUsageData={activitiesWithUsageData}/>
        </div></Modal>
}

export default TeacherPortalStudentModal;       